import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
import { failureHash } from "./promocode.static";
export class ApiEpBillingPromocode {
}
ApiEpBillingPromocode.inspect = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/promocode/${req.path.code}/inspect`,
    method: "GET",
}, failureHash);
ApiEpBillingPromocode.redeem = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/promocode/${req.path.code}/redeem`,
    method: "POST",
}, failureHash);
//# sourceMappingURL=promocode.js.map